import { Button } from '@monavate/ui-core';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { setIsOpenSelectClientModal } from '@/reduxStore/slices/rolesSlice';

const ButtonContainer = styled.div`
    width: 100%;
    padding: 16px;
`;

const CustomButton = styled(Button)`
    width: 100%;
`;

const ViewAsClientButton = () => {
    const dispatch = useDispatch();

    const onButtonClickHandler = () => {
        dispatch(setIsOpenSelectClientModal({ isOpen: true }));
    };
    return (
        <ButtonContainer>
            <CustomButton handleClick={onButtonClickHandler} dataTestId="button-view-as-client">
                View as client
            </CustomButton>
        </ButtonContainer>
    );
};

export default ViewAsClientButton;
